"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.HashableNativeContent = void 0;
var SparkMD5 = require("spark-md5");
var resource_1 = require("../../common/resource");
var HashableNativeContent = /** @class */ (function (_super) {
    __extends(HashableNativeContent, _super);
    function HashableNativeContent(content) {
        var _this = _super.call(this, "HashableNativeContent") || this;
        _this.content = content;
        _this.resource = content;
        _this.log.info("created");
        return _this;
    }
    HashableNativeContent.prototype.size = function () {
        return this.resource.size();
    };
    HashableNativeContent.prototype.md5 = function () {
        var _this = this;
        this.log.info("starting to get hash");
        return this.use(function (content) {
            return content.size().then(function (contentSize) {
                var chunkSize = 4 * 1024 * 1024;
                var spark = new SparkMD5.ArrayBuffer();
                var hash = "";
                var currentOffset = 0;
                var readNext = function () {
                    var nextTargetOffset = currentOffset + chunkSize;
                    var count = nextTargetOffset >= contentSize
                        ? contentSize - currentOffset
                        : chunkSize;
                    return content.readBuffer(currentOffset, count).then(function (buffer) {
                        currentOffset += buffer.byteLength;
                        spark.append(buffer);
                        if (currentOffset === contentSize) {
                            hash = spark.end();
                            _this.log.info("md5 computed: ".concat(hash));
                            return hash;
                        }
                        return readNext();
                    });
                };
                return readNext();
            });
        });
    };
    HashableNativeContent.prototype.isDisposed = function () {
        return this.disposed;
    };
    HashableNativeContent.prototype.dispose = function () {
        this.resource = null;
        this.disposed = true;
    };
    return HashableNativeContent;
}(resource_1.Resource));
exports.HashableNativeContent = HashableNativeContent;
